<template>
  <div class="choose-course">
    <ul>
      <li v-for="(item, index) in data" :key="index" class="chapter-list">
        <div class="chapter-list-header">
          <div
            class="chapter-plus"
            :class="item.active ? 'is-active' : ''"
            @click.self="onItemClick(item)"
          />
          <div class="chapter-list-content" @click.self="onItemClick(item)">
            {{ item.lesson_name }}
          </div>
        </div>
        <ul class="packItem-list" v-show="item.active">
          <li
            v-for="(packItem, packIndex) in item.packInfo"
            :key="packIndex"
            class="packItem-item"
            :class="[packItem.active ? 'is-checked' : '']"
          >
            <div
              class="packItem-item-content"
              @click.stop="
                choicePackItem(index, packIndex, packItem['active'], packItem)
              "
              :class="[packItem.active ? 'is-checked' : '']"
              v-if="packItem.list && packItem.list.length > 0"
            >
              <p>{{ packItem.tag_name }}({{ packItem.list.length }})</p>
            </div>
            <ul class="tagItem-list" v-show="packItem.active">
              <li
                class="tagItem-item"
                :class="[tagItem.active ? 'is-checked' : '']"
                v-for="(tagItem, tagIndex) in packItem.list"
                :key="tagIndex"
                @click="choiceSingle(tagItem['active'], packItem, tagItem)"
              >
                <p>
                  {{ tagItem.tag_name }}
                </p>
              </li>
            </ul>
          </li>
        </ul>
      </li>
    </ul>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import { getQuestionPackageList } from '@/api/pt';

export default {
  name: 'ChooseTagCode',
  props: {
    data: {
      type: Array,
      default: () => [],
    },
    type: {},
  },
  data() {
    const { fromType } = this.$route.query;
    return {
      scienceArr: [2, 4, 5],
      fromType,
      knowledgeList: [],
      choiceKnowledgeList: [],
      currentTagCode: '',
    };
  },
  computed: {
    ...mapGetters([
      'commonWrongCategoryObj',
      'atKnowledgeList',
      'categoryObj',
    ]),
    category() {
      if (this.type === 'CommonWrong') {
        return this.commonWrongCategoryObj;
      }
      return this.categoryObj;
    },
  },
  methods: {
    // 模块点击操作，获取下面的知识点列表
    onItemClick(item) {
      this.$set(item, 'active', !item.active);
      const courseInfo = {
        courseId: item.course_id,
        courseName: item.course_name,
        lessonId: item.lesson_id,
      };
      this.$store.commit('CHANGE_COURSE_INFORMATION', courseInfo);
      if (!item.packInfo && item.active) {
        this.getQuestionPackageList(item);
      }
    },
    // 获取知识点列表
    getQuestionPackageList(item) {
      this.knowledgeList = [];
      const params = {
        subject_id: this.category.subjectId,
        // hw_type: this.fromType,
        hw_type: 3,
        module_id: item.module_id,
      };
      getQuestionPackageList(params).then((res) => {
        if (res.code === 200) {
          const knowledgeArr = res.data;
          knowledgeArr.forEach((knowledge) => {
            knowledge.list.forEach((tag) => {
              this.$set(tag, 'active', false);
            });
            this.knowledgeList.push({
              topic_id: params.module_id,
              id: knowledge.id,
              tag_name: knowledge.name,
              k_module: knowledge.k_module,
              k_module_name: knowledge.k_module_name,
              list: knowledge.list,
              rand_id: knowledge.rand_id,
              sort: knowledge.sort,
              active: false,
              type: '文科',
            });
          });
          this.$store.commit('SET_TOPIC_LIST', this.knowledgeList);
          this.$set(item, 'packInfo', this.knowledgeList);
        }
      });
    },
    // 点击一个模块
    choicePackItem(index, packIndex, isChecked, lesson) {
      this.$set(this.data[index].packInfo[packIndex], 'active', !isChecked);
      this.currentTagCode = '';
      this.data.forEach((dataItem) => {
        if (dataItem.packInfo && dataItem.packInfo.length > 0) {
          dataItem.packInfo.forEach((packItem) => {
            packItem.list.forEach((listItem) => {
              this.$set(listItem, 'active', false);
            });
            if (packItem.id === lesson.id) {
              packItem.list.forEach((listItem) => {
                this.currentTagCode += `,${listItem.tag_code}`;
              });
              this.currentTagCode = this.currentTagCode.substring(1);
              this.$set(lesson, 'tag_code', this.currentTagCode);
              this.$emit('toggleTag', packItem);
            }
          });
        }
      });
    },
    // 点击一个知识点
    choiceSingle(isChecked, packItem, tagItem) {
      this.data.forEach((dataItem) => {
        if (dataItem.packInfo && dataItem.packInfo.length > 0) {
          dataItem.packInfo.forEach((packCItem) => {
            if (packCItem.list && packCItem.list.length > 0) {
              packCItem.list.forEach((tagCItem) => {
                this.$set(tagCItem, 'active', false);
                if (tagCItem.tag_code === tagItem.tag_code) {
                  this.$set(tagCItem, 'active', true);
                  this.$emit('toggleTag', packItem, tagItem);
                }
              });
            }
          });
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.choose-course {
  padding-bottom: 10px;
  .chapter-list {
    display: flex;
    margin-top: 10px;
    flex-wrap: wrap;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: bolder;
    color: #000000;
    .chapter-plus {
      height: 12px;
      width: 18px;
      color: rgba(0, 0, 0, 1);
      font-size: 16px;
      background-repeat: no-repeat;
      background-size: 12px 12px;
      background-image: url("~@/views/pt/images/plus.png");
      &.is-active {
        background-image: url("~@/views/pt/images/minus.png");
      }
    }
    .chapter-list-header {
      display: flex;
      align-items: baseline;
      justify-content: flex-start;
    }
    .packItem-list {
      width: 100%;
      .packItem-item {
        // padding-left: 38px;
        margin-top: 16px;
        font-weight: 400;
        color: rgba(96, 98, 102, 1);
        font-size: 15px;
        margin: 13px 0;
        .packItem-item-content {
          display: flex;
          align-items: baseline;
          justify-content: flex-start;
          padding-right: 5px;
          padding-left: 38px;
          background: url("~@/views/pt/images/plus.png") no-repeat 20px 4px;
          background-size: 12px 12px;
          &.is-checked {
            background-image: url("~@/views/pt/images/minus_2.png");
            // color: rgba(25, 137, 250, 1);
          }
        }
        .tagItem-list {
          width: 100%;
          .tagItem-item {
            padding-left: 56px;
            margin-top: 16px;
            font-weight: 400;
            color: rgba(96, 98, 102, 1);
            font-size: 15px;
            margin: 13px 0;
            background: url("~@/views/pt/images/minus_2.png") no-repeat 38px 4px;
            background-size: 12px 12px;
            &.is-checked {
              color: rgba(25, 137, 250, 1);
            }
          }
        }
      }
    }
  }
}
</style>
